import { ArrowUp } from "lucide-react";
import { LogoMark } from "./Logo";

export default function Footer({ onBackToTop }) {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#D4AF37]/20 bg-[#050505] py-10"
        >
            <div className="mx-auto flex max-w-[1500px] flex-col items-center justify-between gap-6 px-5 sm:flex-row sm:px-10">
                <div className="flex items-center gap-3">
                    <LogoMark size={26} />
                    <span className="font-mono-lux text-[10px] tracking-[0.3em] text-[#8A8A8E]">
                        LE GARS DE LA PHOTO
                    </span>
                </div>
                <p className="font-mono-lux text-center text-[10px] tracking-[0.25em] text-[#8A8A8E]">
                    © 2026 LE GARS DE LA PHOTO — DANIEL DULUDE. TOUS DROITS
                    RÉSERVÉS.
                </p>
                <button
                    data-testid="back-to-top-button"
                    onClick={onBackToTop}
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] transition-all duration-500 hover:bg-[#D4AF37] hover:text-[#050505]"
                    aria-label="Retour en haut"
                >
                    <ArrowUp size={17} />
                </button>
            </div>
        </footer>
    );
}
